/**
 * The portal's address format, as pure string functions.
 *
 * Separated from {@link Router} the way the engine separates `computeCanvasSize` from the canvas and
 * `textTextureKey` from the asset cache: the format is a decision worth pinning down on its own,
 * while the wiring to `window` is thin enough to read. Nothing here touches the page.
 */

/** The address of the game picker. */
export const HOME_HASH = '#/';

const GAME_PREFIX = '#/play/';

/**
 * Reads the game id out of an address hash, or `undefined` when it names the home screen.
 *
 * An address that carries the prefix but no id is the home screen rather than a game called "", so a
 * truncated link lands somewhere real instead of asking the shell to look up a game with no name.
 */
export function parseRouteHash(hash: string): string | undefined {
  if (!hash.startsWith(GAME_PREFIX)) {
    return undefined;
  }

  const id = decodeURIComponent(hash.slice(GAME_PREFIX.length));
  return id === '' ? undefined : id;
}

/** Builds the address of a game, escaping the id so any registry key survives the round trip. */
export function gameHash(gameId: string): string {
  return `${GAME_PREFIX}${encodeURIComponent(gameId)}`;
}
